import React from 'react'
import Divider from '@components/Divider'
import PageTitle from '@components/PageTitle'
import { Layout, Stack, Main } from '@layout'
import Seo from '@widgets/Seo'
import { Heading, Text } from 'theme-ui'
import { Card as CardComponent } from 'theme-ui'

const PageContact = props => {
  return (
    <Layout {...props}>
      <Seo title='COVID-19対応病棟で勤務する看護師のモラルジレンマ' />
      <Divider />
      <Stack>
        <Main>
          <PageTitle
            header='COVID-19対応病棟で勤務する看護師のモラルジレンマ'
            subheader=''
          />
          <CardComponent variant='paper'>
            <div style={{padding: "0 2rem"}}>
            <Heading as='h2'>１．目的</Heading>
            <Text>
            　COVID-19禍にあっては、その対応病棟で多くのモラルジレンマが発生していることが懸念されました。そこでCOVID-19病棟勤務経験のある看護師を対象に、そのモラルジレンマの実態と特徴について質的研究にて調査することを目的にインタビュー調査を実施しました。
           </Text>
            <br />
            <Heading as='h2'>２．インタビュー内容（半構造化面接）</Heading>
            下記の３つの質問を軸に、COVID-19病棟で勤務していた時のことについて、自由に語っていただきました。
            <ul>
              <li>
                COVID-19対応病棟で働くということを知ったときどんなことを考えたか
              </li>
              <li>
                COVID-19対応病棟で勤務してみてどうだったか
              </li>
              <li>
                当時を振り返ってみて、今だから考えること
              </li>
            </ul>
            <br />
            <Heading as='h2'>３．調査期間・方法</Heading>
            <ul>
              <li>2022年3月～2023年1月</li>
              <li>COVID-19病棟で勤務経験のある看護師を対象としたインタビュー調査</li>
            </ul>
            <br />
            <Heading as='h2'>４．調査結果</Heading>
            <Heading as='h3'>1．基本属性</Heading>
            <ul>
              <li>看護職者12名（男性4名、女性8名)</li>
              <li>年代：20～60歳代</li>
              <li>役職(当時)：看護師長3名、主任・副看護師長3名、スタッフ6名</li>
              <li>経験年数4～10年4名、11～20年4名、21年名以上4名</li>
              <li>週の労働時間：COVID-19前44.2時間/週、COVID-19以降43.3時間/週</li>
              <li>インタビュー時間：平均20.5分</li>
            </ul>
            <Heading as='h3'>2．ジレンマの内容</Heading>
            　７つのサブカテゴリー、３つのカテゴリーが抽出されました。
            「どこで感染するかわからない怖さ」という［COVID-19に感染する怖さ］、
            「コロナ病棟への配属は隠していた」という［COVID-19対応病棟で勤務していることを公言できないストレス］という
            <b>【COVID-19そのものに関連したジレンマ】</b>が生じていました。
            「話が来たら断る理由はない」という［看護師としての使命感・責任感］、
            「他部署の人とのつながりができた」「団結して頑張れた」「すごくいい経験をさせてもらった」という［経験の重要性］を語っており、
            「期間がわかっているから楽だった」「業務がこなせるか不安」という［慣れない業務へのストレス］がありながらも
            <b>【仕事のやりがいに関連したジレンマ】</b>を抱いていました。
            また、「一緒に分かち合ってほしかった」「やっていることを評価してほしかった」という［上層部への思い］があり、
            「仲間でやっている感が薄い」や「対応の仕方をもっと考えるべきだった」という［スタッフ間の連携］に対してポジティブな思いとネガティブな思いが
            <b>【人とのつながりの重要さに関連したジレンマ】</b>を抱いていました。
            <br />
            <br />
            <Heading as='h2'>5. 考察</Heading>
            <Text>
            　COVID-19禍では当初負の反応・倫理的課題に否定的な反応が予想されましたが、
            今回のインタビュー調査ではそのような状況の中にも今回の経験の重要性を語る部分も多くあり、
            これは先行研究での看護師は様々な倫理的課題に肯定的な反応を示している<sup>1）</sup>との報告にも一致しました。
            また、肯定的な反応の中にも組織の十分な理解が必要との報告があり、個人と組織の方針が一致しない場合、個人はジレンマを抱えやすくなり、
            バーンアウトなどメンタルヘルスの悪化の報告<sup>2）</sup>もあります。
            今回のインタビュー調査からも個人と組織の方針が一致しない場合のモラルジレンマは多くの方が語られており、これはとても重要な課題と考えられました。
            そのため、COVID-19対応の看護師は、物理的・心理的に多くのジレンマを抱えて<sup>3）4）</sup>いるからこそ、組織は物理的な支援だけでなく、
            看護師に対して心理的な支援体制を整え精神的ストレスの軽減や連携の強化を意識した支援策が解決につながると考えられます。
            <br />
            <br />
            <br />
            <br />
            </Text>
            <Heading as='h2'>【引用文献】</Heading>
            <ol type='1'>
              <li>
                Yuxiu J, Ou C, Zhiying X, Juan X, Junping B & Hongying J:
                Nurses’ ethical challenges caring for people with COVID-19 A
                qualitative study, 2021, Nursing Ethics, 28(1),33-45.
              </li>
              <li>
                A Jameton: Dilemmas of moral distress: moral responsibility and
                nursing practice. AWHONNS Clin Issues Perinat Womens Health
                Nurse, 1993.
              </li>
              <li>
                Oda J, Tanabe S, Nishimura T, Muguruma T, Matsuyama S, Sugawara
                Y, &Ogura S. Nationwide Survey on the response to the first wave
                of COVID-19 in Japan. Part I: How to set up a treatment system
                in each hospital. Acute Medicine & Surgery, 2020, 7(1), 1-9.
              </li>
              <li>
                Lai J, Ma S, Wang Y, Cai Z, Hu J, Wei N, Wu J, et al.,: Factors
                Associated With Mental Health Outcomes Among Health Care Workers
                Exposed to Coronavirus Disease 2019, Journal of American Medical
                Association Network Open, 2019, 3(3) e203976.
              </li>
            </ol>
            </div>
          </CardComponent>
        </Main>
      </Stack>
    </Layout>
  )
}

export default PageContact
